'use client';

import { PropsWithChildren, useState } from 'react';
import { CookieConsent, CookieConsentContext } from '@/features/cookie-consent';


type CookieConsentProviderProps = PropsWithChildren<{
    initialConsent: CookieConsent | null
}>;


export function CookieConsentProvider ({
    initialConsent,
    children,
}: CookieConsentProviderProps) {
    const [ consent, setConsent ] = useState(initialConsent);

    async function saveConsent (
        nextConsent: CookieConsent,
    ): Promise<void> {
        const response = await fetch('/api/cookie-consent', {
            method : 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body   : JSON.stringify(nextConsent),
        });

        if (!response.ok) {
            throw new Error('Failed to save cookie consent');
        }

        setConsent(nextConsent);
    }

    return (
        <CookieConsentContext.Provider value={ { consent, saveConsent } }>
            { children }
        </CookieConsentContext.Provider>
    );
}
